import type { NFTI } from '@tacans/shared-marketplace-layer';
import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';
import { useAvailableCopies } from 'src/features/common/collectible/hooks/use-available-copies';
import { CreateLotModal } from 'src/features/common/collectible/modals/create-lot-modal';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';
import { Button } from 'src/ui/common/atoms/button';
import { getNftTypeByStandard } from 'src/utils/lot.utils';
import { useGetActiveTokenTransaction } from '../../hooks/useGetActiveTokenTransaction.hook';
import { useActionWithAuthorization } from './actions.hooks';

export const CreateLotAction: React.VFC<{ nft: NFTI }> = ({ nft }) => {
    const { t } = useTranslation(['actions']);
    const { isMultiple } = getNftTypeByStandard(nft.standard);
    const availableCopies = useAvailableCopies();
    const { isNinjaTemplate, isOceanTemplate, isSyndicate } = useGetUniverseTemplate();

    const activeTransactions = useGetActiveTokenTransaction();

    const burnCallback = useCallback(async () => {
        CreateLotModal.open({
            nft,
        });
    }, [nft]);

    const actionWithAuthorization = useActionWithAuthorization({
        callback: burnCallback,
    });

    const getButtonVariant = useCallback(() => {
        if (isNinjaTemplate) {
            return 'roundedInverse';
        }
        if (isOceanTemplate) {
            return 'o_purple';
        }
        if (isSyndicate) {
            return 'white';
        }
        return 'gradient';
    }, [isNinjaTemplate, isOceanTemplate]);

    return (
        <Button
            onClick={actionWithAuthorization}
            disabled={!availableCopies || !!activeTransactions[0]}
            size="lg"
            data-test-id="create-lot-btn"
            variant={getButtonVariant()}
        >
            {t('trade.listForSale')}
            {isMultiple && ` (${availableCopies})`}
        </Button>
    );
};